import React from "react";
import { Icon } from "antd";
import styles from "./styles/multiSelectHeader.scss";

const MultiSelectHeader = ({ title, onCancel }) => (
  <div className={styles.header}>
    <span className={styles.title}>
      {title || "Kategorija"}
    </span>
    <Icon type="close" onClick={onCancel} className={styles.closeButton} />
  </div>
);

MultiSelectHeader.defaultProps = {
  title: ""
};

export default MultiSelectHeader;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelectModal/MultiSelectHeader.tsx